import { API_AUTH } from './common';

const TinChapApi = {
  list: ({
    dateFrom,
    dateTo,
    code,
    customerName,
    address,
    noteTaiSan,
    status,
    debt,
    userName,
    manhanvien,
    pageIndex,
    pageSize,
    taiSan = 0,
  }) =>
    API_AUTH.get(
      `quanlychovay/danh-sach-tin-chap?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&taiSan=${taiSan}&manhanvien=${manhanvien}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),
  detail: (choVayId) =>
    API_AUTH.get('cho-vay/chi-tiet?choVayId=' + choVayId, {}),
  addAndEdit: ({ ChoVay, Customer, IsChoDuyet = false, IsCopy = false , ChoVayThamDinhTaiSan }) =>
    API_AUTH.post('quanlychovay/add-tin-chap', {
      ChoVay,
      Customer,
      IsChoDuyet,
      IsCopy,
      ChoVayThamDinhTaiSan,
    }),
  checkEditChoVay: (choVayId) =>
    API_AUTH.post(
      `quan-ly-cho-vay/kiem-tra-sua-cam-do?chovayId=${choVayId}`,
      {}
    ),
};

export default TinChapApi;
